/*eslint-disable */
// //the linter generates an error about App.default.  Imported JSX component default must be in PascalCase or SCREAMING_SNAKE_CASE  react/jsx-pascal-case
// //However this is what React needs to render the app.
import React from 'react';
import { render } from 'react-dom';
import { Api } from 'Utils/api';
import * as Sentry from '@sentry/react';

import 'bootstrap/dist/css/bootstrap.min.css';

const getSentryEnvironment = () => {
  const { hostname } = window.location;
  const apiUrl = import.meta.env.VITE_APP_API_URL || '';
  const mode = import.meta.env.MODE;

  if (hostname === 'app.rocketplantech.com' || hostname === 'www.rocketplantech.com') {
    return 'production';
  }

  if (hostname === 'web-staging-mongoose-n5tr2spgf.rocketplantech.com' || apiUrl.includes('api-staging-')) {
    return 'staging';
  }

  if (hostname === 'web-qa-mongoose-br2wu78v1.rocketplantech.com' || apiUrl.includes('api-qa-')) {
    return 'qa';
  }

  if (mode === 'production') {
    return 'production';
  }

  if (mode === 'staging') {
    return 'staging';
  }

  return 'qa';
};

// Sentry integration on production, staging, and qa
if (window.location.hostname !== 'test.rocketplantech.com') {
  Sentry.init({
    dsn: 'https://cc9581db4cc94680a8ede2385b796888@o537211.ingest.sentry.io/5662701',
    integrations: [new Sentry.BrowserTracing()],
    environment: getSentryEnvironment(),
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}
// Need to get the google api loaded
const script = document.createElement(`script`);
script.src = import.meta.env.VITE_GOOGLE_API;
document.body.appendChild(script);
//Add an event listener for the script tag.  This will ensure that the Google api is loaded before the app
//Make the callback async so we can use the await keyword, when importing the App component
// Routes that use external SSO (GHL) and don't require Laravel CSRF
const isExternalSsoRoute = () => {
  const path = window.location.pathname;
  return path.startsWith('/crm') || path.startsWith('/ghl');
};

script.addEventListener(`load`, async () => {
  //We need to dynamically import the App component, after the google maps api has been loaded.
  //This prevents the error Uncaught ReferenceError: google is not defined.
  //Ie, in the maps.ts file, this error will occur if the api has not be instantiated
  //before the App component is rendered.

  // Skip CSRF check for external SSO routes (GHL embed)
  if (isExternalSsoRoute()) {
    const App = await import('./app');
    render(<App.default />, document.getElementById('app'));
    return;
  }

  Api.csrfHeader().then(async (exists: boolean) => {
    if (exists) {
      //Dynamically import the App component
      const App = await import('./app');
      render(<App.default />, document.getElementById('app'));
      return;
    }
    //Todo we need to create an error page with contact info for support
    alert('Please contact support.  The application cannot load.');
  });
});
